<template>
  <div class="col-12 col-sm-12 col-md-4 block1" :class="order">
    <div class="cat-header d-table w-100">
      <div class="d-table-cell align-middle text-center"
           v-bind:class="category">{{ categoryTitle | capitalize }}</div>
    </div>
    <transition :name="slideWay" mode="out-in">
    <ListOneContent
        :key="category + activeMonth"
        :items="items"
        :category="category"
    />
    </transition>
  </div>
</template>

<script>
import filter from 'lodash/filter';
import includes from 'lodash/includes';

import { mapState, mapGetters } from 'vuex';
import * as Fuse from 'fuse.js';

import ListOneContent from './ListOneContent.vue';

const IMG_PATH = '/img/';

const fuzzy = (items, search) => {
  const options = {
    id: 'id',
    shouldSort: true,
    tokenize: true,
    threshold: 0.6,
    location: 0,
    distance: 100,
    maxPatternLength: 32,
    minMatchCharLength: 3,
    keys: [
      'fr'
    ]
  };

  const fuse = new Fuse(items, options); //
  return fuse.search(search);
};

export default {
  components: {
    ListOneContent
  },
  props: [
    'category',
    'data'
  ],
  computed: {
    ...mapGetters([
      'slideWay'
    ]),
    ...mapState([
      'activeMonth',
      'search'
    ]),
    categoryTitle() {
      return this.data.fr;
    },
    items() {
      const items = this.$store.getters.getActiveMonthCategory(this.category);

      if (this.search.length > 0) {
        const ids = fuzzy(items, this.search);
        return filter(items, v => includes(ids, v.id));
      }

      return items;
    },
    order() {
      return [`order-${this.data.ordering.mobile}`, `order-md-${this.data.ordering.desktop}`];
    }
  },
  filters: {
    picture: (value, category) => `${IMG_PATH}${category}/${value}.png`
  }
};
</script>

<style scoped lang="scss">
  .block1 {
    // gutter
    padding: 0 10px !important;

    @include media-breakpoint-down(sm) {
      margin-bottom: 10px;
    }

    overflow: hidden;
  }

  .cat-header {
    height: 43px;
    margin-bottom: 1px;

    div {
      color: $title-color;
      // font-weight: bold;
      font-family: 'Dekko', cursive;
      font-size: 1rem;

      opacity: 0.95;

      -webkit-box-shadow: 0px -2px 6px -1px rgba(0,0,0,0.29);
      -moz-box-shadow: 0px -2px 6px -1px rgba(0,0,0,0.29);
      box-shadow: 0px -2px 6px -1px rgba(0,0,0,0.29);

      &.fruits {
        background: rgba(203, 60, 56, 0.95);
      }

      &.vegetables {
        background: rgba(16, 43, 96, 0.95);
      }

      &.herbs {
        background: rgba(134, 22, 87, 0.95);
      }
    }
  }

  /* enter */

  .slide-prev-enter {
    transform: translateX(-120%);
  }

  .slide-next-enter {
    transform: translateX(120%);
  }

  .slide-current-enter {
    transform: translateY(-100%);
  }

  .slide-prev-enter-to, .slide-next-enter-to, .slide-current-enter-to {
    transform: translate(0%, 0%);
    transition: transform 200ms ease-out;
  }

  /* leave */

  .slide-prev-leave-active, .slide-next-leave-active, .slide-current-leave-active {
    transition: transform 200ms ease-in;
    // transition: opacity 1000ms ease;
  }

  .slide-prev-leave-to {
    transform: translateX(120%);
  }

  .slide-next-leave-active {
    transform: translateX(-120%);
  }

  .slide-current-leave-active {
    transform: translateY(100%);
  }
</style>
